module.exports = __webpack_public_path__ + "static/media/tip-modal-logo.0e016437.png";